export enum DialogType {
    ConfirmDialog,
    InformationDialog,
    WarningDialog,
    ErrorDialog,
    LoadingDialog
}



// WEBPACK FOOTER //
// ./src/app/modules/domain/enums/dialog-type.ts